import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsPreselectedCheckbox.module.scss';

interface IProps {
	toggleIsPreselected: () => void;
	isPreselected: boolean;
	isDisabled: boolean;
}

export const IsPreselectedCheckbox: React.FC<IProps> = React.memo(
	({ toggleIsPreselected, isPreselected, isDisabled }) => {
		return (
			<Form.Item className={style.container} name="isPreselected" data-test="IsPreselectedCheckbox">
				<Checkbox onChange={toggleIsPreselected} checked={isPreselected} disabled={isDisabled}>
					<Text translationNameSpace="form" translationKey="isPreselectedLabel" asFragment={true} />
				</Checkbox>
			</Form.Item>
		);
	},
);
